import React from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Modal from '../../../../../components/common/Modal'
import { api } from '../../../../../configs/api'
import { useCompany } from '../../../../../context/CompanyContext'
import { ContactType } from './ContactsForm'

const ContactsDelete = ({
    open,
    handleClose,
    data
}: {
    open: boolean
    handleClose: () => void
    data: ContactType | null
}) => {
    const { detail, getCompany } = useCompany()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const handleDelete = async () => {
        if (!data || !detail) return
        const id = data.id
        if (!id) {
            toast.error('Contato não encontrado!')
            return
        }

        try {
            const response = await fetch(`${api}company/contact/delete`, {
                method: 'POST',
                body: JSON.stringify({ contactID: id })
            })

            const result = await response.json()
            if (!result.success) {
                toast.error(result.message || 'Erro ao excluir o contato!')
                return
            }

            getCompany(String(detail.company.id))
            toast.success('Contato excluído com sucesso!')
            handleClose()
        } catch (error) {
            console.log(error)
        }
    }

    if (!open || !data) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir Contato'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-gray-800 dark:text-white/90 text-sm'>
                    <p>
                        Tem certeza que deseja exluir o contato{' '}
                        <strong className='text-error-400'>
                            {data.name} #{data.id}
                        </strong>{' '}
                        ? Esta ação é irreversível.
                    </p>
                </div>
            </form>
        </Modal>
    )
}

export default ContactsDelete
